export const EXTERNAL_BUSINESS_FIELD_LABELS: Record<string, string> = {
  entityName: 'Registered Company Name',
  id: 'NZ Business Number',
  industryClassificationCode: 'Industry Classification Code',
  industryDescription: 'Industry Description',
  entityStatus: 'Entity Status',
  businessType: 'Business Type',
  entityType: 'Entity Type',
  registrationDate: 'Registration Date',
  directorInformation: 'Director Info',
  registeredAddress: 'Registered Address'
};

export const EXTERNAL_BUSINESS_FIELD_PLACEHOLDERS: Record<string, string> = {
  entityName: 'Enter company name',
  id: 'Enter NZ business number',
  industryClassificationCode: 'Enter industry code',
  industryDescription: 'Enter industry description',
  entityStatus: 'Enter entity status',
  businessType: 'Enter business type',
  entityType: 'Enter entity type',
  registrationDate: 'Enter registration date',
  directorInformation: 'Enter director information',
  registeredAddress: 'Enter registered address'
};

export const EXTERNAL_BUSINESS_SUBFIELDS = Object.entries(
  EXTERNAL_BUSINESS_FIELD_LABELS
).map(([key, label]) => ({ key, label }));

export const EXTERNAL_BUSINESS_MODELER_SUBFIELDS = [
  { key: 'entityName', label: 'Registered Company Name', disabled: true },
  { key: 'businessType', label: 'Business Type', disabled: false },
  { key: 'id', label: 'NZ Business Number', disabled: false },
  { key: 'entityType', label: 'Entity Type', disabled: false },
  {
    key: 'industryDescription',
    label: 'Industry Classification',
    disabled: false
  },
  { key: 'registrationDate', label: 'Registration Date', disabled: false },
  {
    key: 'industryClassificationCode',
    label: 'Industry Classification Code',
    disabled: false
  },
  { key: 'directorInformation', label: 'Director Info', disabled: false },
  { key: 'entityStatus', label: 'Entity Status', disabled: false },
  { key: 'registeredAddress', label: 'Registered Address', disabled: false }
];
